import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-33ff4913"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex align-items-center justify-content-end gutter-x-s2 -ml-s2 sm:ml-s0" }

import { computed } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'PercentButton',
  props: {
    activePercent: null,
    disabled: { type: Boolean },
    buttonStyle: null
  },
  emits: ["change"],
  setup(__props: any, { emit: emits }: { emit: ({
  (e: 'change', value: '25' | '50' | '75' | '100'): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  activePercent?: string;
  disabled?: boolean;
  buttonStyle?: string;
}





const percentage = ['25', '50', '75', '100'];

const setPercentValue = value => {
  emits('change', value);
};
const isActive = percent => {
  return percent === props.activePercent;
};
const buttonClass = computed(() => {
  return props.buttonStyle === 'rounded'
    ? `button-${props.buttonStyle} button-sm button-base h-2rem`
    : `button-max percent-button`;
});

return (_ctx: any,_cache: any) => {
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(percentage, (percent) => {
        return _createElementVNode("div", {
          class: "wrapper",
          key: percent
        }, [
          _createVNode(_component_Button, {
            label: percent === '100' ? 'MAX' : percent + '%',
            class: _normalizeClass([{ active: isActive(percent) }, _unref(buttonClass)]),
            onClick: ($event: any) => (setPercentValue(percent)),
            disabled: !!__props.disabled
          }, null, 8, ["label", "class", "onClick", "disabled"])
        ])
      }), 64))
    ])
  ]))
}
}

})